import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";
import { withShop } from "./web/shopfixes.js";

const DirectoryPage = withShop(lazy(() => import("./web/DirectoryPage.js").then((m) => ({ default: m.DirectoryPage }))));
const ApprovedPage = withShop(lazy(() => import("./web/ApprovedPage.js").then((m) => ({ default: m.ApprovedPage }))));
const NoticesPage = withShop(lazy(() => import("./web/NoticesPage.js").then((m) => ({ default: m.NoticesPage }))));
const ManagePage = withShop(lazy(() => import("./web/ManagePage.js").then((m) => ({ default: m.ManagePage }))));
const RebatesPage = withShop(lazy(() => import("./web/RebatesPage.js").then((m) => ({ default: m.RebatesPage }))));
const FilesPage = withShop(lazy(() => import("./web/FilesPage.js").then((m) => ({ default: m.FilesPage }))));

export default defineWebModule({ manifest, pages: { "": DirectoryPage, "/approved": ApprovedPage, "/notices": NoticesPage, "/files": FilesPage, "/rebates": RebatesPage, "/manage": ManagePage } });
